import { fallback } from "@tanstack/router-zod-adapter";
import { z } from "zod";
import { MESSAGE_TAG } from "./message";

export const GetGroupsParamSchema = z.object({
	status: z.enum(["active", "closed"]).default("active").optional(),
	search: z.string().optional(),
	page: z.number().int().optional(),
	limit: z.number().int().optional(),
});

export type GetGroupsParamSchema = z.infer<typeof GetGroupsParamSchema>;

export const CHAT_DIRECT_TABS_VALUE = {
	ALL: "all",
	QUESTION: MESSAGE_TAG.QUESTION,
	TOPIC: MESSAGE_TAG.TOPIC,
	MEDIA: MESSAGE_TAG.MEDIA,
} as const;

export type CHAT_DIRECT_TABS_VALUE =
	(typeof CHAT_DIRECT_TABS_VALUE)[keyof typeof CHAT_DIRECT_TABS_VALUE];

export const CHAT_GROUP_TABS = {
	...CHAT_DIRECT_TABS_VALUE,
	AI: MESSAGE_TAG.AI,
	PUBLISHED: MESSAGE_TAG.PUBLISH,
} as const;

export type CHAT_GROUP_TABS_VALUE =
	(typeof CHAT_GROUP_TABS)[keyof typeof CHAT_GROUP_TABS];

export const ChatGroupSearchSchema = z.object({
	tab: fallback(z.nativeEnum(CHAT_GROUP_TABS), CHAT_GROUP_TABS.ALL).default(
		CHAT_GROUP_TABS.ALL,
	),
	q: z.string().optional(),
});

export type ChatGroupSearchSchema = z.infer<typeof ChatGroupSearchSchema>;
